import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { MaterialActions } from "./Material.type";
import { formatQuery } from "../Utils";

export function* fetchMaterials(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/material?${formatQuery(action)}`);
    yield put({
      type: MaterialActions.FETCH_MATERIAL_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MaterialActions.FETCH_MATERIAL_ERROR,
      payload: error,
    });
  }
}

export function* fetchMaterialBalanaces(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/material/balance?${formatQuery(action)}`);
    yield put({
      type: MaterialActions.FETCH_MATERIAL_BALANCE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: MaterialActions.FETCH_MATERIAL_BALANCE_ERROR,
      payload: error,
    });
  }
}

export function* watcherFetchMaterials() {
  yield takeLatest(MaterialActions.FETCH_MATERIAL, fetchMaterials);
}

export function* watcherFetchMaterialBalances() {
  yield takeLatest(MaterialActions.FETCH_MATERIAL_BALANCE, fetchMaterialBalanaces);
}
